module.exports = __webpack_public_path__ + "static/media/9-CONSENT-WORKSHOP.b4500652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/9-CONSENT-WORKSHOP.jpg
// module id = 145
// module chunks = 0